module.exports = __webpack_public_path__ + "static/img/monitormc.24dd2b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/monitormc.png
// module id = xUSH
// module chunks = 0